<template>
  <section class="vehicle-form">
    <former-form
      :sections="sections"
      :button="button"

      @error="setFieldErrors"
      @change="change"
      @edit="setField"
      @submit="submit"
    />
  </section>
</template>

<script>
  import { mapState } from 'vuex';

  import former from '@/helpers/mixins/former';
  import preload from '@/helpers/mixins/preload';
  import dataHelper from '@/_CRUDL/helpers/data/items';

  import vehicleMap from '@/views/Settings/Vehicles/Form/maps';

  import sections from '@/views/Settings/Vehicles/Form/sections';

  import FormerForm from '@/components/Former/Form.vue';

  const MAPS = {
    vehicle_type: vehicleMap.type,
    fuel: vehicleMap.fuel,
    vehicle_brand: vehicleMap.brand,
    year_start: vehicleMap.year_start,
    year_end: vehicleMap.year_end,
  };

  export default {
    name: 'VehicleForm',
    components: {
      FormerForm,
    },
    mixins: [
      former,
      preload,
    ],
    data() {
      return {
        sections: sections(),
        vehiclePictureInputID: 'vehiclePicture',
      };
    },
    computed: {
      ...mapState([
        'vehicleModels',
      ]),

      button() {
        return {
          icon: 'check',
          label: 'Salvar veículo',
        };
      },
    },
    mounted() {
      this.getVehicleDomains();

      this.getVehicle();

      this.setFieldCallback(vehicleMap.publish, this.changedRequiredFields);
    },
    methods: {
      getVehicleDomains() {
        Object.keys(MAPS).forEach((id) => {
          this.setFieldProcessing(MAPS[id], true);
        });

        return this.preloadVehicleDomains().then(this.gotVehicleDomains);
      },
      gotVehicleDomains() {
        Object.keys(MAPS).forEach((id) => {
          this.setFieldOptions(
            MAPS[id],
            dataHelper(this.vehicleDomains.list.items[id]),
            'name',
            'id',
          );

          this.setFieldProcessing(MAPS[id], false);
        });
      },

      getVehicle() {
        const {
          id,
        } = this.$route.params;

        if (id) {
          this.setFieldProcessingBulk(vehicleMap, true);

          this.$store
            .dispatch('vehicleModels/read', { id })
            .then(this.gotVehicle);
        }
      },
      gotVehicle() {
        const {
          active,
          publish,
          vehicle_type: type,
          fuel,
          vehicle_brand: brand,
          name,
          version,
          year_start: yearStart,
          year_end: yearEnd,
          molicar_code: molicarCode,
          fipe_code: fipeCode,
          public_price_cents: priceCents,
          public_picture: picture,
        } = this.vehicleModels.read.item;

        const sfv = this.setFieldValue;

        sfv(vehicleMap.active, active);
        sfv(vehicleMap.publish, publish);
        sfv(vehicleMap.name, name);
        sfv(vehicleMap.version, version);
        sfv(vehicleMap.year_start, yearStart);
        sfv(vehicleMap.year_end, yearEnd);
        sfv(vehicleMap.molicar_code, molicarCode);
        sfv(vehicleMap.fipe_code, fipeCode);
        sfv(vehicleMap.price_cents, priceCents);
        sfv(vehicleMap.picture, picture);
        if (type) {
          this.setFieldValue(vehicleMap.type, type.id);
        }

        if (fuel) {
          this.setFieldValue(vehicleMap.fuel, fuel.id);
        }

        if (brand) {
          this.setFieldValue(vehicleMap.brand, brand.id);
        }

        this.setFieldProcessingBulk(vehicleMap, false);
      },

      changedRequiredFields() {
        const MAP_REQUIRED_FIELDS = {
          price: vehicleMap.price_cents,
          picture: vehicleMap.picture,
        };

        const publish = this.getFieldValue(vehicleMap.publish);

        if (publish) {
          Object.keys(MAP_REQUIRED_FIELDS).forEach((id) => {
            this.setFieldValidations(MAP_REQUIRED_FIELDS[id], [{
              type: 'blank',
            }]);
          });
        } else {
          Object.keys(MAP_REQUIRED_FIELDS).forEach((id) => {
            this.setFieldValidations(MAP_REQUIRED_FIELDS[id], []);
            this.setFieldErrors(MAP_REQUIRED_FIELDS[id], []);
          });
        }
      },

      getJSON() {
        const gfv = this.getFieldValue;

        return {
          active: gfv(vehicleMap.active),
          publish: gfv(vehicleMap.publish),
          vehicle_type_id: gfv(vehicleMap.type),
          fuel_id: gfv(vehicleMap.fuel),
          vehicle_brand_id: gfv(vehicleMap.brand),
          name: gfv(vehicleMap.name),
          model_version: gfv(vehicleMap.version),
          year_start: gfv(vehicleMap.year_start),
          year_end: gfv(vehicleMap.year_end),
          molicar_code: gfv(vehicleMap.molicar_code),
          fipe_code: gfv(vehicleMap.fipe_code),
          public_price_cents: gfv(vehicleMap.price_cents, { clean: true }),
          public_picture: gfv(vehicleMap.picture),
        };
      },

      submit() {
        const {
          id,
        } = this.$route.params;

        const json = this.getJSON();
        const payload = json;

        if (id) {
          payload.id = id;
        }

        this.$store
          .dispatch(`vehicleModels/${id ? 'update' : 'create'}`, payload)
          .then(this.submitSuccess);
      },
      submitSuccess() {
        this.$router.push({
          name: 'settings-vehicles',
        });
      },

      change(id, value) {
        if (id !== this.vehiclePictureInputID) {
          this.setFieldValue(id, value);
        } else {
          const payload = {
            public_picture: null,
          };

          if (value) {
            let json;
            try {
              json = JSON.parse(value);
            } catch (err) { /* */ }

            if (json && json.key && json.name) {
              json = {
                remote_file_id: json.key,
                original_filename: json.name,
              };
            }

            payload.public_picture = json;
          } else {
            payload.public_picture = {
              remote_file_id: null,
            };
          }

          const {
            id: vehicleID,
          } = this.$route.params;

          if (vehicleID) {
            payload.id = vehicleID;
          }

          if (payload.public_picture) {
            this.setFieldValue(id, value);

            this.$store
              .dispatch('vehicleModels/update', payload)
              .catch(() => {
                this.setFieldValue(id, '');
                this.setFieldErrors(id, ['não foi possível enviar o arquivo']);
              });
          }
        }
      },
    },
  };
</script>

<style lang="scss" scoped></style>
